<div>
    <div visIframeDimensions [dimensionMultiplier]="dimensionMultiplier" [visType]="visType">
        <iframe (load)="loadHandler()" scrolling="no" width="100%" frameborder="0" [src]="iframeURL"> </iframe>
    </div>
</div>
